export default "__VITE_ASSET__C5ZBA6zL__"